module.exports = __webpack_public_path__ + "img/inskin.2a8184ce.png";